import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getDutyTariffLibAsync = createAsyncThunk(
  'libraries/dutyAndTariff',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/tariff', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDutyTariffCountriesAsync = createAsyncThunk(
  'libraries/dutyAndTariff/countries',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/tariff/country', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDutyTariffTotalCountAsync = createAsyncThunk(
  'libraries/dutyAndTariff/total-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/tariff/metadata', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDutyTariffDestinationCountriesAsync = createAsyncThunk(
  'libraries/dutyAndTariff/destination-countries',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/tariff/getDestinationCountry', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloadDutyTariffAsync = createAsyncThunk(
  'libraries/dutyAndTariff/download',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/tariff/download', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDutyTariffLastUpdatedDateAsync = createAsyncThunk(
  'libraries/dutyAndTariff/get-last-updated-date',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/tariff/getUpdatedDate', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getLevelFiltersDataAsync = createAsyncThunk(
  'libraries/duty-and-tariff/get-filter-level-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/tariff/filters', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getTariffAnnouncementDetailsAsync = createAsyncThunk(
  'libraries/duty-and-tariff/get-tariff-announcement-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      `v2/tariff/history?tariff_id=${payload.id}&country=${payload.country}`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const downloadDutyTariffAnnouncementAsync = createAsyncThunk(
  'libraries/dutyAndTariffAnnouncement/download',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/tariff/download-history', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getTariffTemplateLogs = createAsyncThunk(
  'tariff-exposure/get-tariff-template-logs',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/tariff-exposure/get-tariff-template-logs', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const uploadTariffTemplate = createAsyncThunk(
  'tariff-exposure/upload-tariff-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/tariff-exposure/upload-tariff-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const downloadTemplate = createAsyncThunk(
  'duty-tariff/download-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/download-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
